"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCheckboxGroup = void 0;
const checkbox_group_1 = require("../../../components/checkbox-group/checkbox-group");
const form_field_1 = require("./form-field");
exports.FormCheckboxGroup = form_field_1.formFieldFactory(checkbox_group_1.CheckboxGroup);
//# sourceMappingURL=form-checkbox-group.js.map